import React from "react";
import InlineSVG from "react-inlinesvg";

export type SmartImageProps = {
  src: string;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
  onLoad?: () => void;
  onError?: () => void;
  onClick?: () => void;
  role?: string;
  tabIndex?: number;
};

const isSvgSrc = (src: string) =>
  typeof src === "string" &&
  (src.startsWith("data:image/svg+xml") || /\.svg(\?.*)?$/i.test(src));

// react-inlinesvg types can be picky in some setups; alias to a FC to satisfy TSX typing
const InlineSVGComponent = InlineSVG as unknown as React.FC<any>;

const ImagePreview: React.FC<SmartImageProps> = ({
  src,
  alt,
  className,
  style,
  onLoad,
  onError,
  onClick,
  role,
  tabIndex,
}) => {
  if (isSvgSrc(src)) {
    return (
      <InlineSVGComponent
        src={src}
        className={className}
        onLoad={onLoad}
        onError={onError}
        onClick={onClick}
        role={role}
        tabIndex={tabIndex}
        style={style}
      />
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      onLoad={onLoad}
      onError={onError}
      onClick={onClick}
      role={role}
      tabIndex={tabIndex}
    />
  );
};

export default ImagePreview;
